export default __webpack_public_path__ + "KaTeX_Size1-Regular.c4ae0d259a8916db2002e0a18556c965.woff";